@if (rimsPhaseInfo) {
  <div class="rims-phase-header">
    <div class="rims-phase-header-title-wrapper">
      <h2 class="h2">{{ rimsPhaseInfo.name }}</h2>
      @if (!!this.rimsPhaseInfo.rimsStepInfos.length) {
        <button class="rims-card-expand-button" mat-icon-button (click)="onExpandToggle()">
          <mat-icon>{{ !expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
        </button>
      }
    </div>
    <p class="body-large">{{ rimsPhaseInfo.description }}</p>
  </div>

  @if (expanded) {
    <div class="rims-phase-steps">
      @for (rimsStepInfo of this.sortedRimsStepInfos; track rimsStepInfo.stepId) {
        <app-rims-card-step
          [rimsStepInfo]="rimsStepInfo"
          [technicalStep]="
            technicalSteps
              ? technicalSteps.find((technicalStep) => technicalStep.rimsStep.$type === rimsStepInfo.stepId)
              : null
          "
        />
      }
    </div>
  }

  @if (this.incidentsPageStore?.isEditMode()) {
    <button
      class="rims-phase-step-add button-primary"
      mat-flat-button
      color="primary"
      (click)="openAddRimsStepModalAsync()"
    >
      <mat-icon>add</mat-icon> Add new step
    </button>
  }
}
